import * as React from "react";
import { Button } from "@sgbs-ui/core";
import { pluralize } from "@ic-anywhere/ic-utils";

interface RibbonBarProps {
  selectedCount: number;
  onCancel: () => void;
  onConfirm: () => void;
  confirmDisabled?: boolean;
}

export const RibbonBar: React.FC<RibbonBarProps> = ({
  selectedCount,
  onCancel,
  onConfirm,
  confirmDisabled = false,
}) => (
  <div
    data-testid="ribbonbar"
    className="d-flex align-items-center fixed-bottom w-100 ribbon-bar bg-info"
    style={{ minHeight: "52px" }}
  >
    <div className="container-xxl">
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className="d-flex align-items-center gap-2">
          <span className="icon icon-outlined">info</span>
          <span>
            {selectedCount} {pluralize("session", selectedCount)} selected
          </span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button btnType="flat" text="Cancel" color="white" onClick={onCancel} />
          <Button btnType="flat" text="Confirm" color="white" disabled={confirmDisabled} onClick={onConfirm} />
        </div>
      </div>
    </div>
  </div>
);
